import { autobind } from "@typed-decorators/autobind";
import classNames from "classnames";
import type { ContextType, KeyboardEvent } from "react";
import { Component } from "react";

import { createFocusHandler } from "../utils/createFocusHandler";

import { KibelaSymbol } from "./shared/kibela_symbol";

import { AppContext } from "~/client/components/shared/AppContext";

interface Props {
  placeholder: string;
  query: string;
  name?: string;
  disabled?: boolean;
  hasFocus?: boolean;
  autoFocus?: boolean;
  containerClassName?: string;
  onQueryChange(query: string): void;
  onKeyDown?(event: KeyboardEvent): void;
  onFocus?(): void;
  onBlur?(): void;
}

export class SearchBox extends Component<Props> {
  static readonly contextType = AppContext;
  declare context: ContextType<typeof AppContext>;

  @autobind
  handleQueryChange(event) {
    this.props.onQueryChange(event.target.value);
  }

  render() {
    return (
      // eslint-disable-next-line @typescript-eslint/naming-convention
      <div className={classNames("searchBox", this.props.containerClassName, "is-wide")}>
        <input
          ref={createFocusHandler(this.props.hasFocus)}
          type="search"
          autoComplete="off"
          autoCorrect="off"
          autoCapitalize="off"
          placeholder={this.props.placeholder}
          value={this.props.query}
          name={this.props.name}
          disabled={this.props.disabled}
          autoFocus={this.props.autoFocus}
          onChange={this.handleQueryChange}
          onKeyDown={this.props.onKeyDown}
          onFocus={this.props.onFocus}
          onBlur={this.props.onBlur}
        />

        <KibelaSymbol id="search" />
      </div>
    );
  }
}
